<template>
<div class="tree-select-container" tabindex="0" @focusin="showDropdown" @focusout="hideDropdown">
  <div class="tree-select-control">
    <div class="tree-select-selected-container">
      <div class="tree-select-selected-item">
        <ul>
          <span></span>
          <div v-for="(item, index) in checkList" :key="index" ><li><el-tag size="mini">{{item}}</el-tag></li></div>
        </ul>
      </div>
    </div>
    <div class="tree-select-input-container">
      <input type="text">
    </div>
    <div class="tree-select-controller-container">
      <div class="tree-select-remove-all-contaienr">
        <button @click.stop="removeAllSelectedItem">
          <i class="el-icon-error"></i>
        </button>
      </div>
      <div class="tree-select-dropdown-toggle-controller-continer">
        <button>
          <i class="el-icon-arrow-down"></i>
        </button>
      </div>
    </div>
  </div>
  <el-collapse-transition>
    <div class="tree-select-dropdown" v-show="!dropdownStatus">
    <!-- <div class="tree-select-dropdown" v-bind:class="{dropdownStatus:dropdownStatus}"> -->
      <ul class="item-folder">
        <itemTree v-for="(item, index) in options" :key="index" :items="item" :index="index" :checkedList="checkedList" v-on:list-update="listUpdate" class="item-unit"/>
      </ul>
    </div>
  </el-collapse-transition>
</div>
</template>

<script>
import itemTree from './itemTree'
import _ from 'lodash'

export default {
  name: 'TreeSelect',
  components: {
    itemTree
  },
  props: [
    'options'
  ],
  data () {
    return {
      // checkList: [],
      checkedList: {},
      dropdownStatus: true
    }
  },
  methods: {
    listUpdate: function (event) {
      this.checkedList = event
      // const tempList = Object.keys(event)
      // this.checkList = tempList.filter(key => event[key])
      this.$emit('list-update', this.checkList)
    },
    showDropdown: function () {
      this.dropdownStatus = false
    },
    hideDropdown: function () {
      this.dropdownStatus = true
    },
    removeAllSelectedItem: function () {
      // 将
      this.checkedList = _.mapValues(this.checkedList, () => false)
      // console.log(this.checkedList)
    }
  },
  computed: {
    checkList: function () {
      return Object.keys(this.checkedList).filter(key => this.checkedList[key])
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-select-container {
  margin-right: 5px;
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  height: 40px;
  width: 240px;
  .tree-select-control {
    border: 1px solid rgb(219, 222, 229);
    border-radius: 4px;
    padding: 0 5px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    &:hover {
      border: 1px solid #c0c4cc;
    }
    .tree-select-selected-container{
      height: 100%;
      .tree-select-selected-item{
        height: 100%;
        ul{
          width: 100%;
          margin: 0;
          padding: 0;
          list-style-type: none;
          display: flex;
          align-items: center;
          height: 100%;
          div {
            // background-color: #66e8ff;
            // padding: 2px;
            // margin-right: 2px;
            // border-radius: 3px;
              li{
              // display: inline-block;
              margin: 0;
              // height: 100%;
              padding: 0;
              // font-size: 8px;
            }
          }
        }
      }
      // need mod

    }
    .tree-select-input-container{
      height: 100%;
      flex: auto;
      input{
        height: 100%;
        border: 0;
        background-color: #fff;
        width: 100%;
        &:focus{
          outline: 0;
        }
      }
    }
    .tree-select-controller-container{
      height: 100%;
      display: flex;
      align-content: center;
      button{
        padding: 0 2px;
        height: 100%;
        border: 0;
        background-color: #fff;
        font-size: 14px;
        color: #c0c4cc;
        &:focus{
          outline: 0;
        }
        &:hover{
          color: #a8acb6;
        }
      }
    }
  }

  .tree-select-dropdown {
    margin-top: 12px;
    position: absolute;
    background: #fff;
    z-index: 999999;
    width: 100%;
    max-height: 350px;
    // top: 47px;
    border: 1px solid rgb(219, 222, 229);
    border-radius: 4px;
    overflow-y: auto;
    padding: 10px 0;

    ul{
      margin: 0;
      list-style-type: none;
      padding-left: 10px;
      // &:hover{
      //   // background-color: #f5f7fa;
      // }
    }
  }
  .dropdownStatus{
    display: none;
  }
}
</style>
